import React, { ReactElement } from 'react';
import { Button, ReviewAccordionFooter } from '@components';

import styles from './SpecialStatementsStep7.module.scss';

import LinkIcon from '../../../../../images/internalLink.svg';

const MentalOrIntellectualDisability = (): ReactElement => (
  <div>
    <p>You must provide supporting evidence from a relevant practitioner or agency (general practitioner (GP), psychiatrist, psychologist, psychiatric nurse, occupational therapist, or accredited mental health social worker or case worker) that explains:</p>
    <span>
      <ul>
        <li>your diagnosis or condition, including the duration, nature, severity, and impact on your life</li>
        <li>how your condition reduced your capacity to control or understand your offending behaviour</li>
        <li>the practitioner’s qualifications and how long they have known you.</li>
      </ul>
    </span>
    <br />
    <p>The supporting evidence should have been completed within the last 12 months.</p>
    <p>You may also include other evidence to support your claim.</p>

    <ReviewAccordionFooter
      selectOptionName="selectTheSpecialOption"
      closeOptionName="closeTheOption"
      itemOption="SelectedSpecialsGroundInfo0"
      isSelectButtonDisabled={false}
      validateFieldsNames={[]}
      isMultiSelect
    />
  </div>
);

const SubstanceAddiction = (): ReactElement => (
  <div>
    <p>You must provide supporting evidence from a relevant practitioner or agency (general practitioner (GP), psychiatrist, psychologist, psychiatric nurse, occupational therapist, or  accredited mental health social worker or case worker) that explains:</p>
    <span>
      <ul>
        <li>your diagnosis or condition, including the duration, nature, severity, and impact on your life</li>
        <li>how your condition reduced your capacity to control or understand your offending behaviour</li>
        <li>the practitioner’s qualifications and how long they have known you.</li>
      </ul>
    </span>
    <br />
    <p>The supporting evidence should have been completed within the last 12 months.</p>
    <p>You may also include other evidence to support your claim.</p>

    <ReviewAccordionFooter
      selectOptionName="selectTheSpecialOption"
      closeOptionName="closeTheOption"
      itemOption="SelectedSpecialsGroundInfo1"
      isSelectButtonDisabled={false}
      validateFieldsNames={[]}
      isMultiSelect
    />
  </div>
);
const Homelessness = (): ReactElement => (
  <div>
    <p>You must provide supporting evidence from a relevant practitioner or agency (health practitioner, financial counsellor, case worker, social worker, or recognised health or welfare service provider) that explains:</p>
    <span>
      <ul>
        <li>your circumstances, including the duration, nature, severity, and impact on your life</li>
        <li>how your condition reduced your capacity to control your offending behaviour</li>
        <li>the practitioner’s qualifications and how long they have known you.</li>
      </ul>
    </span>
    <br />
    <p>The supporting evidence should have been completed within the last 12 months.</p>
    <p>You may also include other evidence to support your claim.</p>

    <ReviewAccordionFooter
      selectOptionName="selectTheSpecialOption"
      closeOptionName="closeTheOption"
      itemOption="SelectedSpecialsGroundInfo2"
      isSelectButtonDisabled={false}
      validateFieldsNames={[]}
      isMultiSelect
    />
  </div>
);
const LongTermDisability = (): ReactElement => (
  <div>
    <p>This category of special circumstances is for people unable to deal with their fines in any way because of severe, disabling, or incapacitating circumstances. Examples include long-term involuntary mental health care, and severe physical or intellectual disability.</p>
    <p>You must provide supporting evidence from a relevant professional (GP, medical specialist, or other practitioner that knows about your circumstances). The evidence should show that your circumstances:</p>
    <span>
      <ul>
        <li>are long-term</li>
        <li>are particularly disabling or incapacitating</li>
        <li>relate mostly to issues other than financial hardship, and</li>
        <li>make it impracticable for you to deal with your fine in any way, including by paying in full or instalments, or through a work and development permit.</li>
      </ul>
    </span>
    <br />
    <p>The evidence should have been completed within the last 12 months.</p>

    <ReviewAccordionFooter
      selectOptionName="selectTheSpecialOption"
      closeOptionName="closeTheOption"
      itemOption="SelectedSpecialsGroundInfo3"
      isSelectButtonDisabled={false}
      validateFieldsNames={[]}
      isMultiSelect
    />
  </div>
);
const FamilyViolence = (): ReactElement => (
  <div>
    <p>The Family Violence Scheme allows people to apply to have their infringement fines withdrawn if their experience of family violence contributed to the offence or it is not safe for them to nominate the responsible person.</p>
    <p>
      You may be eligible to have your fines reviewed under the
      {' '}
      <a href="/Support/Family-Violence-Scheme" target="_blank" rel="noopener noreferrer">
        Family Violence Scheme
      </a>
      . If your application is successful, you can request that the fines are withdrawn or you can nominate the responsible driver. For more information, see
      {' '}
      <a href="/Support/Family-Violence-Scheme" target="_blank" rel="noopener noreferrer">
        Family Violence Scheme
      </a>
      .
    </p>
    <p>
      You will need to provide supporting evidence. The
      {' '}
      <a href="/-/media/Files/A-Guide-to-the-Family-Violence-Scheme.ashx" target="_blank" rel="noopener noreferrer">
        Guide to the Family Violence Scheme
      </a>
      {' '}
      provides guidance on what evidence to include.
    </p>
    <p>
      If you need help or have questions about the process, please call
      {' '}
      <a href="tel:1300019983" title="Fines Victoria phone number">
        1300 019 983
      </a>
      {' '}
      between 9 am and 5 pm weekdays, except public holidays.
    </p>
    <div className={styles.buttonContainer}>
      <Button
        className={styles.ButtonStyle}
        color="transparent"
        size="medium"
        onClick={() => {
          window.open('/Support/Family-Violence-Scheme', '_blank');
        }}
      >
        <>
          <u>
            Apply under the Family Violence Scheme
          </u>
          {' '}
          <img className={styles.linkIcon} src={LinkIcon} alt="test" />
        </>
      </Button>
    </div>
    <p>If you prefer to make a family violence application under Special Circumstances, you will need to show that the family violence contributed to you having a significantly reduced capacity to control your behaviour.</p>
    <p>If you are successful, the enforcement agency may withdraw the fine, withdraw the fine and issue a warning or withdraw the fine and take you to court.</p>
    <p>
      You will need to provide supporting evidence. See
      {' '}
      <a href="/Support/Special-circumstances" target="_blank" rel="noopener noreferrer">
        Special Circumstances
      </a>
      {' '}
      for guidance on what evidence to include.
    </p>
    <ReviewAccordionFooter
      selectOptionName="selectTheSpecialOption"
      closeOptionName="closeTheOption"
      itemOption="SelectedSpecialsGroundInfo4"
      isSelectButtonDisabled={false}
      validateFieldsNames={[]}
      isMultiSelect
    />
  </div>
);

export { MentalOrIntellectualDisability, SubstanceAddiction, Homelessness, LongTermDisability, FamilyViolence };
